<template>
  <div>
    <b-modal size="lg" id="modalEditBuildings" ref="modalEditBuildings" :title="$t('building')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.house_id">
          <b-form-input type="text" disabled v-model="editItem.house_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Connected on')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <flat-picker
            @onDateChanged="(unixDate) => {editItem.connect_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(editItem.connect_date ? editItem.connect_date : new Date()/1000 ).toDate())}"
            />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Zip code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.post_code"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Country')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.country"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Province/State')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="editItem.region"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('City')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.city"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Street')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.street"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group>
            <b-form-select :options="readyStreets" v-model="curStreet"/>
            <b-input-group-append>
              <md-button class="md-raised" @click="addSteet" style="margin-top:0px">{{ $t('Add') }}</md-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Building#')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.number"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Constr.#')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.building"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Description')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-textarea v-model="editItem.description" rows="2" />
        </b-form-group>
        <b-row align-h="center">
          <md-button class="md-raised" @click="showModalIpZones">{{ $t('Add ip zone') }}</md-button>
        </b-row>
        <b-table striped hover small
            :items="editItem.zones_detailed"
            :fields="zones_detailedFields">
            <template v-slot:cell(actions)="row">
              <i @click.stop="ClickOnDeleteIpZonesButton(row)" class="danger fa fa-trash-alt fa-lg" />
          </template>
        </b-table>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditBuildings')"/>
      </div>
    </b-modal>
    <b-modal hide-footer size="lg" ref="modalIpZones" id="modalIpZones" :title="$t('IP zones')">
      <ipZone ref="ipZone" id="ipZone"
      @ClickOnEditButton="onClickIpZoneRow"
      :hideAddButton=true
      :hidePerPage=true
      :hideEditButtonIPzones=true
      :upCallEditRow=true
      :dropActions=true
      ></ipZone>
    </b-modal>
  </div>
</template>

<script>
import ipZone from '@/pages/referenceBook/IPzone/main'

export default {
  components: {
    ipZone
  },
  props: {
    editItem: null
  },
  data () {
    return {
      curStreet: 1,
      selectedIpZones: null,
      fieldsIpZones: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true}
      ],
      zones_detailedFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      deleteImage: require('@/assets/img/document_delete.png')
    }
  },
  methods: {
    onClickIpZoneRow (ipZone) {
      this.selectedIpZones = ipZone
      this.addIpZones()
      this.$refs.modalIpZones.hide()
    },
    addSteet () {
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/STREETS']))) {
        if (this.curStreet === el.street_id) {
          this.editItem.country = el.country
          this.editItem.region = el.region
          this.editItem.city = el.city
          this.editItem.street = el.street
        }
      }
    },
    showModalIpZones () {
      this.$refs.modalIpZones.show()
      this.selectedIpZones = null
    },
    rowClickIpZones (row) {
      this.selectedIpZones = row
    },
    ClickOnDeleteIpZonesButton (row) {
      this.editItem.zones_detailed = this.editItem.zones_detailed.filter((value) => {
        return value !== row.item
      })
    },
    addIpZones () {
      if (this.selectedIpZones) {
        for (let el of this.editItem.zones_detailed) {
          if (this.selectedIpZones.id === el.id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This IP zone is already in use'), 'Error')
            return
          }
        }
        this.editItem.zones_detailed.push(this.selectedIpZones)
        this.$refs.modalIpZones.hide()
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select IP zone'), 'Error')
      }
    },
    save () {
      if (!this.editItem.zones_detailed.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('IP zones table is empty'), 'Error')
        return
      }
      this.editItem.ip_zones = this.editItem.zones_detailed
      let response = this.editItem.house_id !== 0
        ? this.$store.dispatch('ReferenceBooks/UPDATE_BUILDINGS', this.editItem)
        : this.$store.dispatch('ReferenceBooks/CREATE_BUILDINGS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$emit('updateBuildingsList')
          this.$refs.modalEditBuildings.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    readyStreets () {
      let tmp = []
      for (let el of this.$store.getters['ReferenceBooks/STREETS']) {
        let newEl = {
          text: '',
          value: 0
        }
        newEl.value = el.street_id
        newEl.text = el.country + ',' + el.region + ',' + el.city + ',' + el.street
        tmp.push(newEl)
      }
      return tmp
    }
  },
  watch: {
    readyStreets: function (val) {
      if (this.readyStreets.length > 0) {
        this.curStreet = this.readyStreets[0].value
      } else {
        this.curStreet = 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/buildings/editModal.vue